import React from 'react';
import { string, number, instanceOf } from 'prop-types';
import ReactHtmlParser from 'react-html-parser';
import cx from 'classnames';
import { Image } from '@thd-olt-component-react/core-ui';
import styles from './article-section.module.scss';
import { ComparisonTable } from './ComparisonTable';

const PROJECT_GUIDE = 'ah';
const INFLUENCER_GUIDE = 'ap';
const Section = ({
  name,
  imageURL,
  imageName,
  instruction,
  articleType,
  stepNumber,
  fields,
  index
}) => {
  const imgClasses = cx(styles.img, 'stretchy');
  const sectionClasses = cx({ [styles['article-sections__section--add-margin-top']]: !!name && !!index });
  const displayStepBox = articleType === PROJECT_GUIDE || articleType === INFLUENCER_GUIDE;
  return (
    <section id={`step-${stepNumber}`} data-testid="section" className={sectionClasses}>
      {name
        && (
          <div className={styles['article-sections__heading']}>
            {displayStepBox
            && (
              <span className={styles['article-sections__step-box']}>
                <span className={cx({ [styles['article-sections__hide']]: articleType === INFLUENCER_GUIDE })}>
                  {stepNumber}
                </span>
              </span>
            )}
            <h2 className={styles['article-sections__name']}>
              {name}
            </h2>
          </div>
        )}
      {fields
      && (
        <ComparisonTable
          fields={fields}
          articleType={articleType}
        />
      )}
      {imageURL
          && (
            <Image
              src={imageURL}
              alt={imageName}
              title={imageName}
              height={454}
              width={727}
              className={imgClasses}
            />
          )}
      {instruction && <div className={styles['article-sections__instruction']}>{ReactHtmlParser(instruction)}</div>}
    </section>
  );
};

Section.propTypes = {
  name: string,
  imageURL: string,
  imageName: string,
  instruction: string,
  articleType: string,
  stepNumber: number,
  index: number,
  fields: instanceOf(Array)
};

Section.defaultProps = {
  name: '',
  imageURL: '',
  imageName: '',
  instruction: '',
  articleType: '',
  stepNumber: 1,
  index: 0,
  fields: []

};
export { Section };
